import moment from 'moment/moment';
import _ from 'lodash';
import { getDollarPrice, getEstCostValue } from './general';
import { timeFormatShort } from '../constants/date';
import { getDateWithOffset, renderDateWithTimeZone } from './timezones';
import { getDateIgnoringTimeAndTimezone } from './date';

export const formatJobsList = jobsGroupedByEvent => {
  let jobsList = [];
  jobsGroupedByEvent.forEach((eventGroup) => {
    const { jobs } = eventGroup;
    const isMultiDay = !!eventGroup.event_id && jobs.length > 1;
    jobs.forEach(job => {
      // date format is 'YYYY-MM-DDT00:00:00' without timezone and we format it to utc date otherwise moment will use
      // local timezone during formatting
      job.start_date = moment.utc(job.start_date).format();
      job.timeShiftUI = renderDateWithTimeZone(moment.utc(job.start_date).format(), timeFormatShort, job.time_zone_id,
        moment.utc(job.end_date).format());
      job.event_id = eventGroup.event_id;
      job.event_name = eventGroup.event_name;
      job.is_lta = eventGroup.is_lta;
      job.is_multi_day = isMultiDay;
      job.job_cost_rate = getDollarPrice(job.job_cost_rate);
      job.total_payment = _.isNull(job.total_payment) ? job.total_payment : getDollarPrice(job.total_payment);
      jobsList = jobsList.concat(job);
    });
  });
  return jobsList;
};

export const formatJobDetails = jobDetails => ({
  ...jobDetails,
  start_date: getDateWithOffset(jobDetails.start_date, jobDetails.time_zone_id),
  end_date: getDateWithOffset(jobDetails.end_date, jobDetails.time_zone_id),
  event: {
    ...jobDetails.event,
    start_date: moment.tz(jobDetails.event.start_date, jobDetails.event.time_zone_id),
    end_date: moment.tz(jobDetails.event.end_date, jobDetails.event.time_zone_id)
  },
  job_cost_rate: getDollarPrice(jobDetails.job_cost_rate),
  worker_pay_rate: getDollarPrice(jobDetails.worker_pay_rate),
  total_payment: _.isNull(jobDetails.total_payment) ? jobDetails.total_payment : getDollarPrice(jobDetails.total_payment)
});

export const formatEventScheduleData = eventData => {
  const eventSkillsLabels = [];
  const eventSkillsIcons = [];
  eventData.jobs.forEach(job => {
    job.timeShiftUI = renderDateWithTimeZone(job.start_date, timeFormatShort, job.time_zone_id, job.end_date);
    job.start_date = getDateWithOffset(job.start_date, job.time_zone_id);
    job.end_date = getDateWithOffset(job.end_date, job.time_zone_id);
    job.job_cost_rate = getDollarPrice(job.job_cost_rate);
    job.total_payment = _.isNull(job.total_payment) ? job.total_payment : getDollarPrice(job.total_payment);
    job.estCost = getEstCostValue(job.job_cost_rate, job.hours, job.quantity_of_workers) || '';
    if (!eventSkillsLabels.find(skillLabel => skillLabel === job.skill_label)) {
      eventSkillsLabels.push(job.skill_label);
    }
    if (!eventSkillsIcons.find(url => url === job.icon_url)) {
      eventSkillsIcons.push(job.icon_url);
    }
  });
  eventData.eventSkillsLabels = eventSkillsLabels;
  eventData.eventSkillsIcons = eventSkillsIcons;
  eventData.start_date = getDateIgnoringTimeAndTimezone(eventData.start_date);
  eventData.end_date = getDateIgnoringTimeAndTimezone(eventData.end_date);
  eventData.total_payment = _.isNull(eventData.total_payment) ? eventData.total_payment : getDollarPrice(eventData.total_payment);
  return eventData;
};



// WEBPACK FOOTER //
// ./src/helpers/fromServer.js